import { initializeApp } from "firebase/app"
import { getAnalytics, logEvent } from "firebase/analytics"
import config from './config'

const firebaseConfig =  config.getFirebase()
// Initialize Firebase
const app = initializeApp(firebaseConfig)
const analytics = getAnalytics(app)
//
export default {
  analytics,
  logEvent
}